/* MONORETRO V3 — product page behaviour. Vanilla JS, ~4 KB. Handles the development catalogue and real products. */
(function () {
  'use strict';
  var d = document;
  var root = d.querySelector('[data-pdp]');
  if (!root) return;

  var dev = root.getAttribute('data-mode') === 'dev';
  var form = d.getElementById('pdp-form');
  var track = root.querySelector('[data-track]');
  var countEl = root.querySelector('[data-count]');
  var colourName = root.querySelector('[data-colour-name]');
  var atc = root.querySelector('[data-atc]');
  var atcLabel = root.querySelector('[data-atc-label]');
  var atcPrice = root.querySelector('[data-atc-price]');
  var priceAmount = root.querySelector('[data-price-amount]');
  var idInput = form.querySelector('[data-variant-id]');
  var colourFs = form.querySelector('[data-opt="colour"]');
  var sizeFs = form.querySelector('[data-opt="size"]');
  var sizeError = form.querySelector('[data-size-error]');
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var msg = function (k) { return root.getAttribute('data-msg-' + k) || ''; };
  var addLabel = atcLabel ? atcLabel.textContent : '';

  var gallery = {}, variants = null, prices = {};
  if (dev) { try { gallery = JSON.parse(track.getAttribute('data-gallery') || '{}'); } catch (e) {} }
  else {
    var vs = d.getElementById('pdp-variants'), ps = d.getElementById('pdp-prices');
    if (vs) { try { variants = JSON.parse(vs.textContent); } catch (e) {} }
    if (ps) { try { prices = JSON.parse(ps.textContent); } catch (e) {} }
  }

  var money = function (cents, id) {
    if (id && prices[id]) return prices[id];
    try { return new Intl.NumberFormat(d.documentElement.lang || undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  var sel = function (fs) { return fs ? fs.querySelector('input:checked') : null; };

  /* ---------- Department (shared garments: one page for Men and Women) ---------- */
  // Cards link with ?d=men|women. Show only that department's model photographs (flats, details and labels stay)
  // and point the breadcrumb and "Also in" link at the department the visitor came from.
  var crumb = root.querySelector('.pdp__crumb');
  var pageDept = crumb ? crumb.getAttribute('data-dept') : '';
  var altDept = crumb ? crumb.getAttribute('data-alt-dept') : '';
  var askDept = (location.search.match(/[?&]d=(men|women)\b/) || [])[1] || '';
  var dept = askDept && (askDept === pageDept || askDept === altDept) ? askDept : pageDept;
  var who = dept === 'women' ? 'f' : dept === 'men' ? 'm' : '';
  if (dept && dept === altDept) {
    root.querySelectorAll('.pdp__crumb [data-alt-href], .pdp__also [data-alt-href]').forEach(function (a) {
      a.setAttribute('href', a.getAttribute('data-alt-href'));
      if (a.hasAttribute('data-alt-text')) a.textContent = a.getAttribute('data-alt-text');
    });
  }
  function keep(w) { return !who || !w || w === who; }
  // Only filter by department when this department has its own people in the gallery (Straight Sweatpants: women only).
  var ownPeople = dev && who && Array.prototype.some.call(track.children, function (f) { return f.getAttribute('data-who') === who; });
  if (dev && who && ownPeople) {
    var slides = Array.prototype.slice.call(track.children);
    var stay = slides.filter(function (f) { return keep(f.getAttribute('data-who')); });
    if (stay.length) {
      slides.forEach(function (f) { if (stay.indexOf(f) < 0) f.remove(); });
      slides.forEach(function (f) { f.classList.remove('pdp__slide--lead'); });
      stay[0].classList.add('pdp__slide--lead');
      var im = stay[0].querySelector('img'); if (im) { im.loading = 'eager'; im.setAttribute('fetchpriority', 'high'); }
    }
  }

  /* ---------- Gallery ---------- */
  var raf = 0;
  function updateCount() {
    if (!countEl) return;
    var n = track.children.length;
    var i = Math.min(n, Math.round(track.scrollLeft / (track.clientWidth || 1)) + 1);
    countEl.textContent = n > 1 ? i + ' / ' + n : '';
  }
  track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(updateCount); }, { passive: true });
  updateCount();

  function renderGallery(colour) {
    var files = (gallery[colour] || []).map(function (f) { return typeof f === 'string' ? [f, ''] : f; });
    var mine = files.filter(function (f) { return keep(f[1]); });
    if (mine.length) files = mine;
    if (!files.length) return;
    var first = track.querySelector('img');
    var fallback = first ? first.alt : '';
    track.textContent = '';
    files.forEach(function (entry, i) {
      var src = entry[0], alt = entry[2] || fallback;
      var f = d.createElement('figure');
      f.className = 'pdp__slide' + (i === 0 ? ' pdp__slide--lead' : '');
      var img = new Image();
      img.className = 'pdp__img'; img.src = src; img.width = 1000; img.height = 1333; img.alt = alt; img.decoding = 'async';
      if (i > 0) img.loading = 'lazy';
      f.appendChild(img); track.appendChild(f);
    });
    track.scrollLeft = 0; updateCount();
  }

  /* ---------- Options ---------- */
  function currentVariant() {
    if (!variants) return null;
    var opts = [];
    form.querySelectorAll('.opt[data-position]').forEach(function (fs) { var c = sel(fs); opts[+fs.getAttribute('data-position') - 1] = c ? c.value : null; });
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var p = 0; p < opts.length; p++) { if (opts[p] !== null && v['option' + (p + 1)] !== opts[p]) { ok = false; break; } }
      if (ok && opts.every(function (o) { return o !== null; })) return v;
    }
    return null;
  }

  function refreshSizes() { /* real products: disable sizes with no available variant for the chosen colour */
    if (!variants || !sizeFs) return;
    var colourPos = colourFs ? +colourFs.getAttribute('data-position') : 0;
    var colourVal = colourFs && sel(colourFs) ? sel(colourFs).value : null;
    var sizePos = +sizeFs.getAttribute('data-position');
    sizeFs.querySelectorAll('input').forEach(function (inp) {
      var ok = variants.some(function (v) {
        return v['option' + sizePos] === inp.value && (!colourPos || v['option' + colourPos] === colourVal) && v.available;
      });
      inp.disabled = !ok;
    });
  }

  function refreshBar() {
    if (!bar) return;
    var c = colourName ? colourName.textContent : '';
    var s = sel(sizeFs);
    bar.querySelector('.pdp__bar-meta').textContent = c + (s ? ' · ' + s.value : '');
    var bb = bar.querySelector('button');
    bb.textContent = bb.hasAttribute('data-notify') ? bb.getAttribute('data-notify') : (s ? addLabel : msg('sticky'));
  }

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (colourFs && colourFs.contains(t)) {
      // real URLs: a colour that is its own product (graphics sweatshirts) has its own page
      var href = t.getAttribute('data-href');
      if (href && href.split('?')[0] !== location.pathname) { location.href = href; return; }
      if (colourName) colourName.textContent = t.getAttribute('data-name') || t.value;
      // analytics: which colours get looked at (custom pixel "MONORETRO pre-launch" forwards it)
      try { Shopify.analytics.publish('np_colour_selected', { product: (launch && launch.querySelector('[data-interest]') || {getAttribute: function () { return root.getAttribute('data-listing'); }}).getAttribute('data-interest') || root.getAttribute('data-listing'), colour: t.value }); } catch (err) {}
      if (dev) renderGallery(t.value);
      refreshSizes();
    }
    if (sizeFs && sizeFs.contains(t)) { sizeFs.classList.remove('is-error'); if (sizeError) sizeError.hidden = true; }
    if (variants) {
      var v = currentVariant();
      if (v) {
        idInput.value = v.id;
        priceAmount.textContent = money(v.price, v.id);
        if (atcPrice) atcPrice.textContent = '· ' + money(v.price, v.id);
        if (atc) atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? addLabel : msg('soldout');
        if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
        if (v.featured_media && window.matchMedia('(max-width: 899px)').matches) {
          var slide = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }
    }
    refreshBar();
  });
  refreshSizes();

  /* ---------- Toast ---------- */
  var toast;
  function showToast(html) {
    if (!toast) { toast = d.createElement('div'); toast.className = 'mr-toast'; toast.setAttribute('role', 'status'); d.body.appendChild(toast); }
    toast.innerHTML = html; toast.classList.add('is-on');
    clearTimeout(showToast.t); showToast.t = setTimeout(function () { toast.classList.remove('is-on'); }, 5200);
  }

  /* ---------- Add to bag ---------- */
  var hv = null;   // real variants behind a catalogue page (settings.real_urls)
  try { var hvEl = d.getElementById('pdp-hvariants'); if (hvEl) hv = JSON.parse(hvEl.textContent); } catch (e) {}
  var preopen = root.hasAttribute('data-preopen');   // pre-launch: browse only, the sign-up is the action
  var launch = d.getElementById('LaunchList');
  function toLaunch() { if (!launch) return; launch.scrollIntoView({ behavior: 'smooth', block: 'center' }); var em = launch.querySelector('input[type=email]'); if (em) em.focus({ preventScroll: true }); }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (preopen) { toLaunch(); return; }
    if (sizeFs && !sel(sizeFs)) {
      sizeFs.classList.add('is-error'); if (sizeError) sizeError.hidden = false;
      sizeFs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = sizeFs.querySelector('input:not(:disabled)'); if (first) first.focus({ preventScroll: true });
      return;
    }
    if (dev && hv) {
      // Catalogue page on a real product: the selected colour and size name the real variant
      var hc = colourFs ? sel(colourFs) : null, hs = sizeFs ? sel(sizeFs) : null;
      var hit = hv.filter(function (x) { return (!hc || x.c === hc.value || hv.every(function (y) { return y.c === hv[0].c; })) && (!hs || x.s === hs.value); })[0];
      if (hit) addVariant(hit.id);
      return;
    }
    if (dev) {
      // Development catalogue: the preview bag (np-shop.js); falls back to the note when the drawer is absent
      if (d.querySelector('[data-np-bag]')) {
        var cIn = colourFs ? sel(colourFs) : null, sIn = sizeFs ? sel(sizeFs) : null;
        window.dispatchEvent(new CustomEvent('np:bag-add', { detail: { id: root.getAttribute('data-listing'), c: cIn ? cIn.value : '', s: sIn ? sIn.value : '' } }));
      } else showToast(root.getAttribute('data-msg-dev') || d.querySelector('[data-devnote]').textContent);
      return;
    }
    var v = currentVariant();
    if (!v) return;
    addVariant(v.id);
  });
  function addVariant(id) {
    if (!atc || atc.disabled) return;
    atc.disabled = true; if (atcLabel) atcLabel.textContent = msg('adding');
    fetch(cartUrl + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        d.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
        if (d.querySelector('[data-np-bag]')) window.dispatchEvent(new Event('np:bag-open'));
        else showToast(msg('added') + ' <a href="' + cartUrl + '">' + msg('view') + '</a>');
      })
      .catch(function () { showToast(msg('error')); })
      .then(function () { atc.disabled = false; if (atcLabel) atcLabel.textContent = addLabel; });
  }

  /* ---------- Fit: measurements follow the selected size ---------- */
  var fit = d.querySelector('[data-fit]');
  if (fit) {
    var fitChart = null;
    try { fitChart = JSON.parse(fit.querySelector('[data-fit-chart]').textContent); } catch (e) {}
    var fitNote = fit.querySelector('[data-fit-note]');
    var setFit = function (size) {
      if (!fitChart) return;
      var i = fitChart.sizes.indexOf(size); if (i < 0) return;
      fit.querySelectorAll('[data-key]').forEach(function (row) {
        var r = fitChart.rows.filter(function (x) { return x.key === row.getAttribute('data-key'); })[0];
        if (r) row.querySelector('[data-fit-val]').textContent = String(r.values[i]).replace('.', fit.getAttribute('data-dec') || '.');
      });
      if (fitNote) fitNote.textContent = fitNote.getAttribute('data-tpl').replace('__SIZE__', size);
      fit.querySelectorAll('[data-size-col]').forEach(function (c) {
        if (c.getAttribute('data-size-col') === size) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
    };
    form.addEventListener('change', function (e) { if (sizeFs && sizeFs.contains(e.target)) setFit(e.target.value); });
  }

  /* ---------- "Measurements" link: open Fit & measurements and bring it into view ---------- */
  d.querySelectorAll('[data-open-fit]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var acc = d.getElementById('pdp-fit'); if (!acc) return;
      e.preventDefault(); acc.open = true;
      acc.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      var sum = acc.querySelector('summary'); if (sum) sum.focus({ preventScroll: true });
    });
  });

  /* ---------- Size guide dialog (legacy; V4 uses the Fit & measurements disclosure) ---------- */
  var dlg = d.getElementById('sizeguide');
  if (dlg) {
    d.querySelectorAll('[data-open="sizeguide"]').forEach(function (b) { b.addEventListener('click', function () { dlg.showModal(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-close]')) dlg.close(); });
  }

  /* ---------- Mobile sticky bar ---------- */
  var bar = null;
  if ('IntersectionObserver' in window) {
    bar = d.createElement('div');
    bar.className = 'pdp__bar'; bar.setAttribute('inert', '');
    bar.innerHTML = '<div class="pdp__bar-info"><span class="pdp__bar-title"></span><span class="spec pdp__bar-meta"></span></div><button class="btn btn--primary" type="submit" form="pdp-form"></button>';
    if (preopen) bar.querySelector('button').setAttribute('data-notify', launch ? launch.querySelector('button').textContent : '');
    bar.querySelector('.pdp__bar-title').textContent = root.querySelector('.pdp__title').textContent;
    d.body.appendChild(bar); refreshBar();
    new IntersectionObserver(function (entries) {
      var on = !entries[0].isIntersecting;
      bar.classList.toggle('is-on', on);
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }, { rootMargin: '0px 0px -8px 0px' }).observe(atc || launch || root.querySelector('[data-closed]') || form);
  }
})();
